module.exports = __webpack_public_path__ + "img/05-full.408a2be2.jpg";